var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollaborationOpportunities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 19.4444C22.0275 19.4444 23.3333 18.1386 23.3333 16.5278C23.3333 14.9169 22.0275 13.6111 20.4167 13.6111C18.8058 13.6111 17.5 14.9169 17.5 16.5278C17.5 18.1386 18.8058 19.4444 20.4167 19.4444Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4367 28.5094C56.0475 28.5094 57.3533 27.2035 57.3533 25.5927C57.3533 23.9819 56.0475 22.676 54.4367 22.676C52.8258 22.676 51.52 23.9819 51.52 25.5927C51.52 27.2035 52.8258 28.5094 54.4367 28.5094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1599 48.619C30.7707 48.619 32.0765 47.3131 32.0765 45.7023C32.0765 44.0915 30.7707 42.7856 29.1599 42.7856C27.549 42.7856 26.2432 44.0915 26.2432 45.7023C26.2432 47.3131 27.549 48.619 29.1599 48.619Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0082 26.3511L18.0036 23.7125L22.7033 23.52L25.5899 26.2685L26.2549 30.1379L14.5094 30.1302L15.0082 26.3511ZM49.0885 35.4181L52.0849 32.7795L56.7846 32.587L59.6701 35.3354L60.3361 39.2049L48.5897 39.1981L49.0885 35.4181ZM23.8049 55.5256L26.8003 52.887L31.501 52.6945L34.3865 55.4429L35.0515 59.3124L23.3061 59.3046L23.8049 55.5256Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 19.4444C22.0275 19.4444 23.3333 18.1386 23.3333 16.5278C23.3333 14.9169 22.0275 13.6111 20.4167 13.6111C18.8058 13.6111 17.5 14.9169 17.5 16.5278C17.5 18.1386 18.8058 19.4444 20.4167 19.4444Z",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 29.1668C14.5833 29.1668 15.5556 24.9756 17.5 24.0033C19.4444 23.0311 21.3889 23.0311 23.3333 24.0033C25.2778 24.9756 26.25 29.1668 26.25 29.1668",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4367 28.5096C56.0475 28.5096 57.3533 27.2038 57.3533 25.5929C57.3533 23.9821 56.0475 22.6763 54.4367 22.6763C52.8258 22.6763 51.52 23.9821 51.52 25.5929C51.52 27.2038 52.8258 28.5096 54.4367 28.5096Z",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6033 38.2318C48.6033 38.2318 49.5756 34.0405 51.52 33.0683C53.4644 32.0961 55.4089 32.0961 57.3533 33.0683C59.2978 34.0405 60.27 38.2308 60.27 38.2308",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1599 48.619C30.7707 48.619 32.0765 47.3131 32.0765 45.7023C32.0765 44.0915 30.7707 42.7856 29.1599 42.7856C27.549 42.7856 26.2432 44.0915 26.2432 45.7023C26.2432 47.3131 27.549 48.619 29.1599 48.619Z",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3265 58.3412C23.3265 58.3412 24.2987 54.1499 26.2432 53.1777C28.1876 52.2055 30.1321 52.2055 32.0765 53.1777C34.021 54.1499 34.9932 58.3402 34.9932 58.3402M51.0922 19.5767C46.9904 14.738 40.8674 11.6667 34.0278 11.6667C31.3347 11.6667 28.7544 12.1431 26.3637 13.0152M38.3376 55.9738C46.3225 54.4144 52.7868 48.6073 55.2806 40.9997M11.7512 32.0717C11.6948 32.7223 11.6666 33.3749 11.6667 34.0279C11.6667 41.7804 15.6119 48.6112 21.6047 52.6236",
    stroke: "white",
    strokeWidth: 0.277778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborationOpportunities);
export default __webpack_public_path__ + "static/media/CollaborationOpportunities.424eb885cf4124c718c48687d63fbc6e.svg";
export { ForwardRef as ReactComponent };